import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const ArrowLittleUpIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.0983 14.1033C16.911 14.2895 16.6575 14.394 16.3933 14.394C16.1292 14.394 15.8757 14.2895 15.6883 14.1033L12.0983 10.5633L8.55834 14.1033C8.37097 14.2895 8.11752 14.394 7.85334 14.394C7.58915 14.394 7.3357 14.2895 7.14834 14.1033C7.05461 14.0103 6.98021 13.8997 6.92945 13.7778C6.87868 13.656 6.85254 13.5253 6.85254 13.3933C6.85254 13.2612 6.87868 13.1305 6.92945 13.0087C6.98021 12.8868 7.05461 12.7762 7.14834 12.6833L11.3883 8.44325C11.4813 8.34952 11.5919 8.27513 11.7138 8.22436C11.8356 8.17359 11.9663 8.14745 12.0983 8.14745C12.2303 8.14745 12.3611 8.17359 12.4829 8.22436C12.6048 8.27513 12.7154 8.34952 12.8083 8.44325L17.0983 12.6833C17.1921 12.7762 17.2665 12.8868 17.3172 13.0087C17.368 13.1305 17.3941 13.2612 17.3941 13.3933C17.3941 13.5253 17.368 13.656 17.3172 13.7778C17.2665 13.8997 17.1921 14.0103 17.0983 14.1033Z"
      fill="currentColor"
    />
  </Icon>
);
